<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item label="分组名">
                <el-input v-model="formInline.groupName" placeholder="查询多个可以用逗号隔开"></el-input>
            </el-form-item>

            <el-form-item label="平台">
                <el-select v-model="formInline.platformId" filterable clearable  placeholder="平台"  >
                    <el-option v-for="item in platformData"
                               :key="item.platformId"
                               :label="item.platformName"
                               :value="item.platformId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="handleAdd">新增</el-button>
                <el-button type="success" @click="handleGetGroups">获取微信分组</el-button>
            </el-form-item>
        </el-form>

            
            <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
              <!--  <el-table-column type="selection" width="55"></el-table-column>-->
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="groupId" label="分组Id"  width="70"></el-table-column>
                <el-table-column prop="groupName" label="分组名" ></el-table-column>
                <el-table-column prop="userCount"  label="分组用户数"></el-table-column>
              <el-table-column prop="unLoadUserCount"  label="未上传用户数"></el-table-column>
<!--              <el-table-column prop="failCount"  label="上传失败用户数"></el-table-column>-->
                <el-table-column prop="groupCount"  label="上传成功用户数"></el-table-column>
                <el-table-column prop="sentCount"  label="送达用户数"></el-table-column>
                <el-table-column prop="keywordName" label="关键字" sortable></el-table-column>
                <el-table-column prop="mediaName" label="素材" sortable  width="180"></el-table-column>
                <el-table-column prop="createTime" label="创建日期" sortable  width="150"></el-table-column>
                <el-table-column prop="message" label="状态" sortable  width="80"></el-table-column>
                <el-table-column label="操作" fixed="right" width="280">
                    <template slot-scope="scope" >
                        <el-button type="text"   @click="handleEdit(scope.row)">修改</el-button>
                        <el-button type="text"    @click="handleDelUser(scope.row)">删除用户</el-button>
                        <el-button type="text"    @click="handleGoGroup(scope.row)">分组</el-button>
                        <el-button type="text"    @click="handleUpload(scope.row)">上传</el-button>
                        <el-button type="text"    @click="handlePrev(scope.row)">预览群发消息</el-button>
                        <el-button type="text"    @click="handleSend(scope.row)">发送群发消息</el-button>
                        <el-button type="text"    @click="handleDel(scope.row)">撤回群发消息</el-button>
                        <el-button type="text"    @click="handlePrevCustomize(scope.row)">预览客服消息</el-button>
                        <el-button type="text"    @click="handleSendCustomize(scope.row)">发送客服消息</el-button>
                        <el-button type="text"    @click="handleGetStatus(scope.row)">查看状态</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
        <el-form :model="form" label-width="80px">
            <el-form-item label="id" :hidden="true">
                <el-input v-model=form.groupId ></el-input>
            </el-form-item>
            <el-form-item label="组名" disabled="disabled">
                <el-input v-model=form.groupName clearable  placeholder="组名"></el-input>
            </el-form-item>
            <el-form-item label="关键字">
                <el-select v-model="form.keywordId"  filterable clearable  placeholder="关键字">
                    <el-option v-for="item in keywordData"
                               :key="item.id"
                               :label="item.keyword"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="关联优惠券绑定码" >
                <el-input v-model="form.bindCode"  clearable placeholder="关联优惠券绑定码"></el-input>
            </el-form-item>


            <el-form-item>

                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save(form)">确 定</el-button>
            </el-form-item>
        </el-form>
        </el-dialog>
        <el-dialog title="分组用户" :visible.sync="dialogGroupFormVisible" center>
            <el-tabs v-model="tabsName">
                <el-tab-pane label="按时间" name="first">
                    <el-form  :model="formGroup1" >
                    <el-form-item label="查询类型">
                        <el-radio v-model="formGroup1.searchType" label="1">按领券日期</el-radio>
                        <el-radio v-model="formGroup1.searchType" label="2">按关注日期</el-radio>
                    </el-form-item>

                    <el-form-item label="日期范围">
                        <el-date-picker
                                v-model="formGroup1.dateRange"
                                type="datetimerange"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item >
                    <el-form-item label="有优惠券">
                        <el-select v-model="formGroup1.haveCashticket"  placeholder="选择优惠券"  >
                            <el-option v-for="item in cashticketData"
                                       :key="item.ticketBatchId"
                                       :label="item.ticketBatchName"
                                       :value="item.ticketBatchId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="无优惠券">
                        <el-select v-model="formGroup1.noCashticket"  placeholder="选择优惠券"  >
                            <el-option v-for="item in cashticketData"
                                       :key="item.ticketBatchId"
                                       :label="item.ticketBatchName"
                                       :value="item.ticketBatchId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="无购买记录">
                        <el-checkbox v-model="formGroup1.buyRecord"></el-checkbox>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="groupSearch1">查询</el-button>
                    </el-form-item>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="按城市" name="second">
                    暂无实现
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getWechatGroupList,getWechatGroups,getWechatGroup,saveWechatGroup,uploadGroupUsers,getSendMessageStatus,sendGroupMessage,delGroupMessage,sendCustomizedMessage,deleteByWechatGroupId,getPlatformList2,getCashticketBatchForOption,searchGroup1} from '../../api/api'
    //定义组件
    export default{
        data(){
            return {
                listData:[],
                platformData:[],
                keywordData:[],
                cashticketData:[],
                loading:true,
                dialogFormVisible:false,
                form:{},
                formGroup1:{"searchType":"1"},
                formInline:{
                    platformId:0,
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                dialogGroupFormVisible:false,
                tabsName:'first',
            }
        },
        //挂载时候执行
        mounted(){
            getPlatformList2(this.formInline).then((res) => {
                this.platformData=res.data;
                this.formInline.platformId=res.data[0].platformId;
                //初始化首页数据
                this.getList();
            });

        },
        methods:{
            getList(){
                getWechatGroupList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.total;
                    this.listData = res.data.list;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleDelUser(row){
                if(confirm("确定删除当前组下的用户吗？")) {
                    deleteByWechatGroupId({platformId: row.platformId,groupId:row.groupId}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }

                    })
                }

            },
            handleAdd(){
                //var d={id:0};
                this.dialogFormVisible = true;
                this.form.groupId=0;
                this.platformDisabled=false;
                //this.handleEdit(d);
                this.getKeyworldList(this.form.groupId);
            },
            handleEdit(data){
                this.dialogFormVisible = true;
                this.platformDisabled=true;
                //得到实体
                this.getKeyworldList(data.groupId);
            },
            getKeyworldList(groupId){
                getWechatGroup({groupId:groupId}).then((res) => {
                    //console.log(res.data);
                    if(res.data.groupEntity!=undefined&&groupId!=0) {
                        this.form = res.data.groupEntity;
                    }
                    this.keywordData=res.data.keywordList;
                });
            },

            save(data){
                console.log(data);

                saveWechatGroup(data).then((res) => {
                    //console.log(res);
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }
                });
            },
            handleGoGroup(data){
                this.dialogGroupFormVisible=true;
                getCashticketBatchForOption({}).then((res)=>{
                    if(res.data.success){
                        this.cashticketData=res.data.value;
                    }
                });


            },
            groupSearch1(){
                //console.log(this.formGroup1);
                if(this.formGroup1.searchType==""){
                    this.$message({
                        message:"请选择查询类型",
                        type:'error'
                    });
                    return;
                }
                if(this.formGroup1.dateRange==undefined){
                    this.$message({
                        message:"请选择日期范围！",
                        type:'error'
                    });
                    return;
                }


                searchGroup1(this.formGroup1).then((res)=>{
                    if(res.data.success){
                        this.dialogGroupFormVisible=false;
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }
                });
            },
            handleUpload(data){
                uploadGroupUsers({platformId:data.platformId,groupId:data.groupId}).then((res) => {
                    //console.log(res);
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }
                });
            },
            handlePrev(data){
                var value = prompt('请输入预览微信号：', '输入');
                if(value == null||value == ''){
                    alert('输入为空，请重新输入！');
                }else{
                    sendGroupMessage({"platformId":data.platformId,"wxuserName":value.trim(),"groupId":data.groupId}).then((res)=>{
                        if(res.data.success){
                            this.$message({
                                message:res.data.message,
                                type:'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                            this.dialogFormVisible=false;
                        }else{
                            this.$message({
                                message:res.data.message,
                                type:'error'
                            });
                        }
                    });
                }


            },
            handleSend(data){
                if(confirm("确认群发消息吗？")) {
                    sendGroupMessage({
                        "platformId": data.platformId,
                        "wxuserName": "",
                        "groupId": data.groupId
                    }).then((res) => {
                        if (res.data.success) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                            this.dialogFormVisible = false;
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            handleDel(data){
                if(confirm("确认撤回消息吗？")) {
                    var value = prompt('要删除的文章在图文消息中的位置，第一篇编号为1,以此类推,填0会删除全部文章', '0');
                    if(value == null||value == ''){
                        alert('输入为空，请重新输入！');
                    }else{
                        delGroupMessage({
                            "platformId": data.platformId,
                            "groupId": data.groupId,
                            "actIndex":value.trim()
                        }).then((res) => {
                            if (res.data.success) {
                                this.$message({
                                    message: res.data.message,
                                    type: 'success'
                                });
                                this.getList(this.currentPage, this.pageSize);
                                this.dialogFormVisible = false;
                            } else {
                                this.$message({
                                    message: res.data.message,
                                    type: 'error'
                                });
                            }
                        });
                    }


                }
            },
            handlePrevCustomize(data){
                var value = prompt('请输入预览微信OPENID：', '0');
                if(value == null||value == ''){
                    alert('输入为空，请重新输入！');
                }else {
                    sendCustomizedMessage({
                        "platformId": data.platformId,
                        "openId": value.trim(),
                        "groupId": data.groupId
                    }).then((res) => {
                        if (res.data.success) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                            this.dialogFormVisible = false;
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            handleSendCustomize(data){
                if(confirm("确认群发客服消息吗？")) {
                    sendCustomizedMessage({
                        "platformId": data.platformId,
                        "openId": "",
                        "groupId": data.groupId
                    }).then((res) => {
                        if (res.data.success) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                            this.dialogFormVisible = false;
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            },
            handleGetStatus(data){
                getSendMessageStatus({
                    "platformId": data.platformId,
                    "groupId": data.groupId
                }).then((res) => {
                    if (res.data.success) {
                        this.$message({
                            message: res.data.value,
                            type: 'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleGetGroups(){
                if(this.formInline.platformId==0||this.formInline.platformId==null){
                    this.$message({
                        message: "请选择平台",
                        type: 'error'
                    });
                    return;
                }
                getWechatGroups({
                    "platformId": this.formInline.platformId
                }).then((res) => {
                    if (res.data.success) {
                        this.$message({
                            message: res.data.value,
                            type: 'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible = false;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            }


        }
    }

</script>



// WEBPACK FOOTER //
// src/views/wechat/wechatGroupList.vue